import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LocaleRestService} from '../../../shared/services/locale/locale-rest.service';
import {Observable} from 'rxjs';
import {Locale} from '../../../shared/types/localization/locale';
import {SecurityRestService} from '../../../shared/services/security/security-rest.service';
import {LocaleChangeService} from '../../../shared/services/locale/locale.change.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'wsd-locale-change',
  templateUrl: './locale-change.component.html',
  styleUrls: ['./locale-change.component.css']
})
export class LocaleChangeComponent implements OnInit {

  @Input()
  private currentLocale: Locale;

  @Output()
  private onChange = new EventEmitter<void>();

  supportedLocales: Observable<Locale[]>;

  constructor(private localeRestService: LocaleRestService,
              private securityRestService: SecurityRestService,
              private localeChangeService: LocaleChangeService,
              private translate: TranslateService) { }

  ngOnInit() {
    this.supportedLocales = this.localeRestService.getSupportedLanguages();
  }

  changeLocale(locale: Locale) {
    if (this.currentLocale.id === locale.id) {
      return;
    }
    this.securityRestService.changeLocale(locale).subscribe(
      (rsp: any) => {
        this.localeChangeService.changedTo(locale);
        this.translate.setDefaultLang(locale.code);
        this.onChange.emit();
      }
    );
  }

}
